import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Resume from './components/Resume';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import Footer from './components/Footer';
AOS.init();

function App() {
  return (
    <div className="App" data-parallax="scroll">
      <Header />
      <Hero />
      <About />
      <Resume />
      <Portfolio />
      <Contact />
      <Footer />
      <div id="preloader"> 
        <div id="loader"></div>
      </div> 
    </div>
  );
}

export default App;
